export const getActivatedCoCounselCase = (cases) => {
  const firstCase = Array.isArray(cases) ? cases[0] : null;
  if (!firstCase) return null;
  const clientId = Number(firstCase.client_id);
  const caseId = Number(firstCase.case_id);
  if (
    !Number.isSafeInteger(clientId) ||
    clientId <= 0 ||
    !Number.isSafeInteger(caseId) ||
    caseId <= 0
  ) {
    return null;
  }
  return { client_id: clientId, case_id: caseId };
};
